import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import RowGroupTable from './RowGroupTable'
import i18n from 'live/services/i18n'
import type { DatabaseModel, GroupModel } from './interface/Group'

interface PropGroupDatabaseTable {
    groupsModels: GroupModel[]
    databaseModels: DatabaseModel[]
    search: string
}

export default function GroupDatabaseTable({
    groupsModels,
    search
}: PropGroupDatabaseTable) {
    return (
        <TableContainer data-cy="groupDatabaseTable" >
            <div className="group-header-div">
                <div className="icon-drop"></div>
                <div className="div-header">{i18n('Database Group')}</div>
                <div className="div-header">{i18n('Number of Databases')}</div>
                <div className="div-header">{i18n('Last Update')}</div>
                <div className="div-header"></div>
            </div>
            {groupsModels
                .filter(group => {
                    return group?.name?.toLowerCase().includes(search.toLowerCase())
                })
                .map((groupModel, index) => {
                    return (
                        <RowGroupTable
                            key={index}
                            groupModel={groupModel}
                        />
                    )
                })}
        </TableContainer>
    )
}

const TableContainer = styled.div`
    margin-top: 32px;
    margin-bottom: 50px;
    .group-header-div {
        display: grid;
        grid-template-columns: 4% 25% 22% 22% 27%;
        margin: auto;
        width: 80%;
        min-width: 680px;
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        color: var(--grey-700);
        padding-bottom: 5px;
        font-style: normal;
        font-weight: 600;
    }

    .div-header {
        padding-left: 10px;
        display: flex;
        text-align: left;
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        font-size: 14px;
        color: var(--grey-700);
    }

    .icon-drop {
        text-align: center;
        justify-content: center;
        width: 50px;
    }
`
const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-size: 14px;
    color: #37a3ef;
    display: flex;
    width: 20px;
    cursor: pointer;
    padding-left: 24px;
`

const IconDown = styled.div`
    cursor: pointer;
    .drop-down {
        color: #37a3ef;
    }
    .drop-down:hover {
        color: #97ccf1;
    }
`

export { IconDown, TableContainer, Icon }
